import {
  TST_FREE_DATA,
  TST_SET_TESTS_LOADING_STATE,
  TST_SET_CURRENT_TEST,
  TST_GET_TEST_STATUS_LIST,
  TST_GET_TEST_TYPES_LIST,
  TST_SET_TESTS_FILTER,
  TST_SET_TESTS_TYPE_FILTER,
  TST_CLEAR_TESTS_LIST,
  TST_GET_TESTS_LIST, // Получение списка аттестаций,
  TST_CREATE_TEST,
  TST_CANCEL_TEST,
  TST_POST_TEST,
  TST_ADD_FILE,
  TST_DEL_FILE,
  TST_CHANGE_COMMENT,
  TST_DELETE_COMMENT,
  TST_SET_CURRENT_Q,
  TST_ADD_QUESTION,
  TST_UPD_QUESTION,
  TST_DEL_QUESTION,
  TST_SET_CURRENT_A,
  TST_ADD_ANSWER,
  TST_UPD_ANSWER,
  TST_DEL_ANSWER,
  TST_GET_USERS,
  TST_ADD_USER,
  TST_DEL_USER,
  TST_SET_TIME,
  TST_SET_ANSWERS,
  TST_GET_REST,
  TST_GET_ACTIONS

} from '../actions/tests'
import { UI_REQUEST, UI_SUCCESS, UI_ERROR } from '../actions/ui'
import axios from 'axios'
const state = {
  currentTest: {},
  currentQuestion: {},
  currentAnswer: {},
  usersList: [],
  testList: [],
  testStatesList: [],
  testTypesList: [],
  currentTestsFilter: null,
  currentTestTypeFilter: null,
  testsListLoading: false
}

const getters = {
  getCurrentTestState: state => state.currentTest.DS_ID,
  getCurrentTestID: state => state.currentTest.DOC_ID,
  getCurrentTest: state => state.currentTest,
  getCurrentQuestion: state => state.currentQuestion,
  getCurrentAnswer: state => state.currentAnswer,
  getCurrentTestComments: state => state.currentTest.COMMENTS_TAB,
  getCurrentTestFiles: state => {
    if (typeof state.currentTest.FILE_LIST !== 'undefined') {
      return state.currentTest.FILE_LIST
    } else {
      return []
    }
  },
  getCurrentTestAvailStates: state => {
    if (typeof state.currentTest.AVAIL_STATUS !== 'undefined') {
      return state.currentTest.AVAIL_STATUS
    } else {
      return []
    }
  },
  getCurrentTestAvailReports: state => state.currentTest.AVAIL_REPORTS,
  getCurrentTestsList: state => state.testList,
  getCurrentUsersList: state => state.usersList,
  getCurrentTestUsersList: state => state.currentTest.USERS,
  getTestStatesList: state => state.testStatesList,
  getTestTypesList: state => state.testTypesList,
  getTestsListLoading: state => state.testsListLoading,
  getCurrentTestsFilter: state => {
    var cf = state.currentTestsFilter
    return cf
  },
  getCurrentTestTypeFilter: state => {
    var tf = state.currentTestTypeFilter
    return tf
  },
  getCurrentTestType: state => {
    var cctID = state.currentTest.DT_ID
    return cctID
  },
  getSelectedAnswers: state => {
    return state.currentQuestion.selectedAnswers || []
  },
  getQuestionsCount: state => {
    return state.currentTest.QUESTIONS.length
  },
  getCurrentQuestionNum: state => {
    return state.currentTest.QUESTIONS.findIndex(itm => itm.CDET_ID === state.currentQuestion.CDET_ID)
  }

}

const actions = {
  [TST_FREE_DATA]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      commit(TST_FREE_DATA)
      resolve('success')
    }),
  [TST_GET_TEST_STATUS_LIST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_GET_TEST_STATUS_LIST', topic: 'Загрузка списка статусов аттестаций', error: null })
      commit(TST_SET_TESTS_LOADING_STATE, true)
      axios({ url: '/api/tests/getTestsStatusList.php', method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_GET_TEST_STATUS_LIST, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'TST_GET_TEST_STATUS_LIST' })
            resolve(resp.data.data)
          } else {
            console.log('Claim status list request error: ', resp.data.error_text)
            dispatch(UI_ERROR, { action: 'TST_GET_TEST_STATUS_LIST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_GET_TEST_STATUS_LIST', result: 'Получение списка возможных статусов аттестаций: ошибка сервера' })
          reject(new Error(err))
        })
        .finally(() => {
          commit(TST_SET_TESTS_LOADING_STATE, false)
        })
    }),
  [TST_GET_TEST_TYPES_LIST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_GET_TEST_TYPES_LIST', topic: 'Загрузка списка типов аттестаций', error: null })
      commit(TST_SET_TESTS_LOADING_STATE, true)
      axios({ url: '/api/tests/getTestTypesList.php', method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_GET_TEST_TYPES_LIST, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'TST_GET_TEST_TYPES_LIST' })
            resolve(resp.data.data)
          } else {
            console.log('Test status list request error: ', resp.data.error_text)
            dispatch(UI_ERROR, { action: 'TST_GET_TEST_TYPES_LIST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_GET_TEST_TYPES_LIST', result: 'Получение списка возможных статусов документа: ошибка сервера' })
          reject(new Error(err))
        })
        .finally(() => {
          commit(TST_SET_TESTS_LOADING_STATE, false)
        })
    }),

  [TST_GET_ACTIONS]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_GET_ACTIONS', topic: 'Загрузка списка возможных действий', error: null })
      commit(TST_SET_TESTS_LOADING_STATE, true)
      var payload = {
        DOC_ID: state.currentTest.DOC_ID,
        INST_ID: state.currentTest.INST_ID,
        USR_ID: state.currentTest.USR_ID,
        DEPT_ID: state.currentTest.DEPT_ID
      }
      axios({ url: '/api/tests/getTestActions.php', data: payload, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_GET_ACTIONS, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'TST_GET_ACTIONS' })
            resolve(resp.data.data)
          } else {
            console.log('Test actions list request error: ', resp.data.error_text)
            dispatch(UI_ERROR, { action: 'TST_GET_ACTIONS', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_GET_ACTIONS', result: 'Получение списка возможных дкйствий: ошибка сервера' })
          reject(new Error(err))
        })
        .finally(() => {
          commit(TST_SET_TESTS_LOADING_STATE, false)
        })
    }),

  [TST_GET_TESTS_LIST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_GET_TESTS_LIST', topic: 'Загрузка списка запросов', error: null })
      console.log('Called action TST_GET_TESTS_LIST, current filter is  ', state.currentTestsFilter)
      commit(TST_CLEAR_TESTS_LIST)
      var filterSet = !(state.currentTestsFilter === null) && !(state.currentTestTypeFilter === null)
      if (filterSet) {
        var reqData = {
          DS_ID: state.currentTestsFilter,
          DT_ID: state.currentTestTypeFilter
        }
      } else {
        reject(new Error('Не установлен фильтр состояний'))
        dispatch(UI_ERROR, { action: 'TST_GET_TESTS_LIST', result: 'Не установлен фильтр состояний' })
        return
      }
      commit(TST_SET_TESTS_LOADING_STATE, true)
      axios({ url: '/api/tests/getTestsListNew.php', data: reqData, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_GET_TESTS_LIST, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'TST_GET_TESTS_LIST' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'TST_GET_TESTS_LIST', result: 'Ошибка получения списка возможных статусов запроса: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_GET_TESTS_LIST', result: 'Получение списка возможных состояний: ошибка сервера' })
          reject(new Error(err))
        })
        .finally(() => {
          commit(TST_SET_TESTS_LOADING_STATE, false)
        })
    }),
  [TST_SET_TESTS_FILTER]: ({ commit, dispatch }, filterItem) =>
    new Promise((resolve, reject) => {
      console.log('Called action TST_SET_TESTS_FILTER] ', filterItem)
      dispatch(UI_REQUEST, { action: 'TST_SET_TESTS_FILTER', topic: 'Установка фильтра запросов', error: null })
      if (filterItem !== state.currentTestsFilter) {
        commit(TST_SET_TESTS_FILTER, filterItem)
        commit(TST_CLEAR_TESTS_LIST)
        dispatch(TST_GET_TESTS_LIST)
          .then(resp => {
            dispatch(UI_SUCCESS, { action: 'TST_SET_TESTS_FILTER' })
            resolve()
          })
          .catch((err) => {
            dispatch(UI_ERROR, { action: 'TST_SET_TESTS_FILTER', result: 'Установка фильтра запросов: ошибка сервера' })
            reject(err)
          })
      } else {
        dispatch(UI_SUCCESS, { action: 'TST_SET_TESTS_FILTER' })
        resolve()
      }
    }),

  [TST_SET_TESTS_TYPE_FILTER]: ({ commit, dispatch }, filterItem) =>
    new Promise((resolve, reject) => {
      console.log('Called action TST_SET_TESTS_TYPE_FILTER] ', filterItem)
      dispatch(UI_REQUEST, { action: 'TST_SET_TESTS_TYPE_FILTER', topic: 'Установка фильтра запросов', error: null })
      if (filterItem !== state.currentTestTypeFilter) {
        commit(TST_SET_TESTS_TYPE_FILTER, filterItem)
        commit(TST_CLEAR_TESTS_LIST)
        dispatch(TST_GET_TESTS_LIST)
          .then(resp => {
            dispatch(UI_SUCCESS, { action: 'TST_SET_TESTS_TYPE_FILTER' })
            resolve()
          })
          .catch((err) => {
            dispatch(UI_ERROR, { action: 'TST_SET_TESTS_TYPE_FILTER', result: 'Установка фильтра запросов: ошибка сервера' })
            reject(err)
          })
        resolve()
      } else {
        dispatch(UI_SUCCESS, { action: 'TST_SET_TESTS_TYPE_FILTER' })
        resolve()
      }
    }),

  [TST_SET_CURRENT_TEST]: ({ commit, dispatch }, requestItem) =>
    new Promise((resolve, reject) => {
      console.log('Called action TST_SET_CURRENT_TEST ', requestItem)
      dispatch(UI_REQUEST, { action: 'TST_SET_CURRENT_TEST', topic: 'Установка активного запросов', error: null })
      if (requestItem.DOC_ID !== state.currentTest.DOC_ID) {
        console.log('Setting new current request', requestItem)
        commit(TST_SET_CURRENT_TEST, requestItem)
      }
      dispatch(UI_SUCCESS, { action: 'TST_SET_CURRENT_TEST' })
      resolve()
    }),
  [TST_SET_CURRENT_Q]: ({ commit, dispatch }, requestItem) =>
    new Promise((resolve, reject) => {
      console.log('Called action TST_SET_CURRENT_Q ', requestItem)
      dispatch(UI_REQUEST, { action: 'TST_SET_CURRENT_Q', topic: 'Установка активного вопроса', error: null })
      if (requestItem.CDET_ID !== state.currentQuestion.CDET_ID) {
        console.log('Setting new current question', requestItem)
        commit(TST_SET_CURRENT_Q, requestItem)
      }
      dispatch(UI_SUCCESS, { action: 'TST_SET_CURRENT_Q' })
      resolve()
    }),
  [TST_SET_CURRENT_A]: ({ commit, dispatch }, requestItem) =>
    new Promise((resolve, reject) => {
      console.log('Called action TST_SET_CURRENT_A ', requestItem)
      dispatch(UI_REQUEST, { action: 'TST_SET_CURRENT_A', topic: 'Установка активного ответа', error: null })
      if (requestItem.ADET_ID !== state.currentAnswer.ADET_ID) {
        console.log('Setting new current answer', requestItem)
        commit(TST_SET_CURRENT_A, requestItem)
      }
      dispatch(UI_SUCCESS, { action: 'TST_SET_CURRENT_A' })
      resolve()
    }),

  [TST_SET_ANSWERS]: ({ commit, dispatch }, answers) =>
    new Promise((resolve, reject) => {
      console.log('Called action TST_SET_ANSWERS ', answers)
      dispatch(UI_REQUEST, { action: 'TST_SET_ANSWERS', topic: 'Установка ответов на текущий вопрос', error: null })
      axios({ url: '/api/tests/setUserAnswers.php', data: answers, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_SET_ANSWERS, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'TST_SET_ANSWERS' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'TST_SET_ANSWERS', result: 'Установка ответов на текущий вопрос: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_SET_ANSWERS', result: 'Установка ответов на текущий вопрос: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [TST_CREATE_TEST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_CREATE_TEST', topic: 'Создание запроса', error: null })
      axios({ url: '/api/tests/createNewTest.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_CREATE_TEST, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'TST_CREATE_TEST' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'TST_CREATE_TEST', result: 'Создание запроса: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_CREATE_TEST', result: 'Создание запроса: ошибка сервера' })
          reject(new Error(err))
        })
    }),
  [TST_GET_REST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      axios({ url: '/api/tests/getTestRest.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_GET_REST, resp.data.data)
            resolve(resp.data.data)
          } else {
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),

  [TST_SET_TIME]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_SET_TIME', topic: 'Установка времени запроса', error: null })
      axios({ url: '/api/tests/setTestTime.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_SET_TIME, params)
            dispatch(UI_SUCCESS, { action: 'TST_SET_TIME' })
            resolve(params)
          } else {
            dispatch(UI_ERROR, { action: 'TST_SET_TIME', result: 'Установка времени: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_SET_TIME', result: 'Установка времени: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [TST_ADD_QUESTION]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_ADD_QUESTION', topic: 'Создание вопроса', error: null })
      axios({ url: '/api/tests/addQuestion.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_ADD_QUESTION, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'TST_ADD_QUESTION' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'TST_ADD_QUESTION', result: 'Создание вопроса: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_ADD_QUESTION', result: 'Создание вопроса: ошибка сервера' })
          reject(new Error(err))
        })
    }),
  [TST_UPD_QUESTION]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_UPD_QUESTION', topic: 'Обновление вопроса', error: null })
      axios({ url: '/api/tests/addQuestion.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_UPD_QUESTION, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'TST_UPD_QUESTION' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'TST_UPD_QUESTION', result: 'Обновление вопроса: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_UPD_QUESTION', result: 'Обновление вопроса: ошибка сервера' })
          reject(new Error(err))
        })
    }),
  [TST_DEL_QUESTION]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_DEL_QUESTION', topic: 'Обновление вопроса', error: null })
      axios({ url: '/api/tests/delQuestion.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_DEL_QUESTION, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'TST_DEL_QUESTION' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'TST_DEL_QUESTION', result: 'Обновление вопроса: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_DEL_QUESTION', result: 'Обновление вопроса: ошибка сервера' })
          reject(new Error(err))
        })
    }),
  [TST_ADD_ANSWER]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_ADD_ANSWER', topic: 'Создание ответа', error: null })
      axios({ url: '/api/tests/addAnswer.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_ADD_ANSWER, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'TST_ADD_ANSWER' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'TST_ADD_ANSWER', result: 'Создание ответа: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_ADD_ANSWER', result: 'Создание ответа: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [TST_UPD_ANSWER]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_UPD_ANSWER', topic: 'Редактирование ответа', error: null })
      axios({ url: '/api/tests/addAnswer.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_UPD_ANSWER, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'TST_UPD_ANSWER' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'TST_UPD_ANSWER', result: 'Редактирование ответа: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_UPD_ANSWER', result: 'Редактирование ответа: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [TST_DEL_ANSWER]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_DEL_ANSWER', topic: 'Редактирование ответа', error: null })
      axios({ url: '/api/tests/delAnswer.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_DEL_ANSWER, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'TST_DEL_ANSWER' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'TST_DEL_ANSWER', result: 'Редактирование ответа: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_DEL_ANSWER', result: 'Редактирование ответа: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [TST_CANCEL_TEST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_CANCEL_TEST', topic: 'Отмена запроса', error: null })
      console.log('TST_CANCEL_TEST action called')
      dispatch(TST_POST_TEST, params)
        .then(resp => {
          console.log('TST_POST_TEST returned responce to TST_CANCEL_TEST', resp)
          if (resp.error === 'ok') {
            console.log('TST_CANCEL_TEST result is OK, commiting TST_CANCEL_TEST mutation')
            commit(TST_CANCEL_TEST, params)
            resolve()
            dispatch(UI_SUCCESS, { action: 'TST_CANCEL_TEST' })
          } else {
            dispatch(UI_ERROR, { action: 'TST_CANCEL_TEST', result: 'Обновление данных по состоянию запроса: ошибка сервера' })
            reject(new Error(resp.error_text))
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_CANCEL_TEST', result: 'Обновление данных по состоянию запроса: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [TST_POST_TEST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_POST_TEST', topic: 'Изменение состояния запроса', error: null })
      axios({ url: '/api/tests/postTest.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_POST_TEST, params)
            resolve(resp.data)
            dispatch(UI_SUCCESS, { action: 'TST_POST_TEST' })
          } else {
            dispatch(UI_ERROR, { action: 'TST_POST_TEST', result: 'Ошибка отправки запроса : ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_POST_TEST', result: 'Ошибка отправки запроса: ошибка сервера' })
          reject(new Error(err))
        })
    }),
  [TST_ADD_FILE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_ADD_FILE', topic: 'Добавление файла в запрос', error: null })
      axios({ url: '/api/tests/uploadTestDocument.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_ADD_FILE, resp.data.data)
            resolve(resp.data)
            dispatch(UI_SUCCESS, { action: 'TST_ADD_FILE' })
          } else {
            dispatch(UI_ERROR, { action: 'TST_ADD_FILE', result: 'Ошибка добавления файла в запрос: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_ADD_FILE', result: 'Добавление данных в запрос: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [TST_DEL_FILE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_DEL_FILE', topic: 'Удаление файла из запроса', error: null })
      axios({ url: '/api/tests/delTestFile.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_DEL_FILE, params)
            resolve(resp.data)
            dispatch(UI_SUCCESS, { action: 'TST_DEL_FILE' })
          } else {
            dispatch(UI_ERROR, { action: 'TST_DEL_FILE', result: 'Удаление файла из запроса КП: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_ADD_FILE', result: 'Удаление файла из запроса КП: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [TST_CHANGE_COMMENT]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_CHANGE_COMMENT', topic: 'Изменение комментария запроса', error: null })
      axios({ url: '/api/tests/updTestComment.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_CHANGE_COMMENT, resp.data.data)
            resolve(resp.data.data)
            dispatch(UI_SUCCESS, { action: 'TST_CHANGE_COMMENT' })
          } else {
            dispatch(UI_ERROR, { action: 'TST_CHANGE_COMMENT', result: 'Ошибка обновления данных в запросе: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_CHANGE_COMMENT', result: 'Обновление данных в запросе на КП: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [TST_DELETE_COMMENT]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_DELETE_COMMENT', topic: 'Удаление комментария запроса', error: null })
      axios({ url: '/api/tests/delTestComment.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_CHANGE_COMMENT, resp.data.data)
            resolve(resp.data.data)
            dispatch(UI_SUCCESS, { action: 'TST_DELETE_COMMENT' })
          } else {
            dispatch(UI_ERROR, { action: 'TST_DELETE_COMMENT', result: 'Ошибка обновления данных в запросе на КП: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_DELETE_COMMENT', result: 'Обновление данных в запросе на КП: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [TST_GET_USERS]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_GET_USERS', topic: 'Удаление комментария запроса', error: null })
      axios({ url: '/api/tests/getUsers.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_GET_USERS, resp.data.data)
            resolve(resp.data.data)
            dispatch(UI_SUCCESS, { action: 'TST_GET_USERS' })
          } else {
            dispatch(UI_ERROR, { action: 'TST_GET_USERS', result: 'Ошибка обновления данных в запросе на КП: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_GET_USERS', result: 'Обновление данных в запросе на КП: ошибка сервера' })
          reject(new Error(err))
        })
    }),
  [TST_ADD_USER]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_ADD_USER', topic: 'Удаление комментария запроса', error: null })
      axios({ url: '/api/tests/addUsers.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_ADD_USER, resp.data.data)
            resolve(resp.data.data)
            dispatch(UI_SUCCESS, { action: 'TST_ADD_USER' })
          } else {
            dispatch(UI_ERROR, { action: 'TST_ADD_USER', result: 'Ошибка обновления данных в запросе на КП: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_ADD_USER', result: 'Обновление данных в запросе на КП: ошибка сервера' })
          reject(new Error(err))
        })
    }),
  [TST_DEL_USER]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'TST_DEL_USER', topic: 'Удаление комментария запроса', error: null })
      axios({ url: '/api/tests/delUsers.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(TST_DEL_USER, resp.data.data)
            resolve(resp.data.data)
            dispatch(UI_SUCCESS, { action: 'TST_DEL_USER' })
          } else {
            dispatch(UI_ERROR, { action: 'TST_DEL_USER', result: 'Ошибка обновления данных в запросе на КП: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'TST_DEL_USER', result: 'Обновление данных в запросе на КП: ошибка сервера' })
          reject(new Error(err))
        })
    })
}

const mutations = {

  [TST_FREE_DATA]: state => {
    state.currentTest = {}
    state.currentQuestion = {}
    state.currentAnswer = {}
    state.testList = []
    state.testStatesList = []
    state.testTypesList = []
    state.currentTestsFilter = null
    state.currentTestTypeFilter = null
    state.testListLoading = false
  },
  [TST_GET_TEST_STATUS_LIST]: (state, resp) => {
    console.log('TST_GET_TEST_STATUS_LIST mutation initiated, ', resp)
    state.testStatesList = resp
  },
  [TST_GET_TEST_TYPES_LIST]: (state, resp) => {
    console.log('TST_GET_TEST_TYPES_LIST mutation initiated, ', resp)
    state.testTypesList = resp
  },
  [TST_CLEAR_TESTS_LIST]: (state) => {
    console.log('TST_CLEAR_TESTS_LIST mutation initiated, ')
    state.testList.splice(0, state.testList.length)
  },
  [TST_GET_TESTS_LIST]: (state, resp) => {
    console.log('TST_GET_TESTS_LIST mutation initiated, ', resp)
    state.testList = resp
  },
  [TST_GET_ACTIONS]: (state, resp) => {
    console.log('TST_GET_ACTIONS mutation initiated, ', resp)
    state.currentTest.AVAIL_STATUS = resp
  },
  [TST_SET_TESTS_FILTER]: (state, resp) => {
    console.log('TST_SET_TESTS_FILTER mutation initiated, ', resp)
    state.currentTestsFilter = resp
  },
  [TST_SET_TESTS_TYPE_FILTER]: (state, resp) => {
    console.log('TST_SET_TESTS_TYPE_FILTER mutation initiated, ', resp)
    state.currentTestTypeFilter = resp
  },
  [TST_SET_TESTS_LOADING_STATE]: (state, resp) => {
    console.log('TST_SET_TESTS_LOADING_STATE mutation initiated, ', resp)
    state.testListLoading = resp
  },
  [TST_SET_CURRENT_TEST]: (state, resp) => {
    console.log('TST_SET_CURRENT_TEST mutation initiated, ', resp)
    state.currentTest = resp
  },
  [TST_SET_CURRENT_Q]: (state, resp) => {
    console.log('TST_SET_CURRENT_Q mutation initiated, ', resp)
    state.currentQuestion = resp
  },
  [TST_SET_CURRENT_A]: (state, resp) => {
    console.log('TST_SET_CURRENT_A mutation initiated, ', resp)
    // eslint-disable-next-line eqeqeq
    const currAns = state.currentQuestion.ANSWERS.find(item => item.ADET_ID == resp.ADET_ID)
    if (currAns) {
      state.currentAnswer = currAns
    } else {
      state.currentAnswer = {}
    }
  },
  [TST_SET_ANSWERS]: (state, resp) => {
    console.log('TST_SET_ANSWERS mutation initiated, ', resp)
    state.currentQuestion.selectedAnswers = resp
    console.log('TST_SET_ANSWERS mutation finished, ', state.currentQuestion.selectedAnswers)
  },
  [TST_CREATE_TEST]: (state, orderItem) => {
    console.log('TST_CREATE_TEST mutation initiated', orderItem)
    // Проверяем, является ли текущий фильтр запросов соответствующим состоянию нового запроса
    var upd = state.testList.findIndex(itm => itm.DOC_ID === orderItem.DOC_ID)
    if (upd === -1) {
      // eslint-disable-next-line eqeqeq
      if (state.currentTestsFilter == orderItem.CS_ID || state.currentTestsFilter == -5) {
        // Если да, то добавляем новый запрос в гобальный список запросов
        state.testList.push(orderItem)
      }
    } else {
      console.log('TST_CREATE_TEST - update detected ', upd)
      state.testList.splice(upd, 1, orderItem)
      state.currentTest = orderItem
    }
  },
  [TST_GET_REST]: (state, resp) => {
    console.log('TST_GET_REST mutation initiated', resp)
    state.currentTest.SCHEDULED_TIME = resp
  },
  [TST_SET_TIME]: (state, resp) => {
    console.log('TST_SET_TIME mutation initiated', resp)
    const index = state.testList.findIndex(itm => itm.DOC_ID === resp.DOC_ID)
    console.log('Test found - ', index)
    if (index !== -1) {
      var newItem = Object.assign({}, state.testList[index])
      newItem.SCHEDULED_TIME = resp.TIME
      state.testList.splice(index, 1, newItem)
    }
  },
  [TST_ADD_QUESTION]: (state, orderItem) => {
    console.log('TST_ADD_QUESTION mutation initiated', orderItem)
    state.currentTest.QUESTIONS.push(orderItem)
  },
  [TST_UPD_QUESTION]: (state, orderItem) => {
    console.log('TST_UPD_QUESTION mutation initiated', orderItem)
    const index = state.currentTest.QUESTIONS.findIndex(itm => itm.CDET_ID === orderItem.CDET_ID)
    console.log('Question found - ', index)
    if (index !== -1) {
      state.currentTest.QUESTIONS.splice(index, 1, orderItem)
      state.currentQuestion = orderItem
    }
  },
  [TST_DEL_QUESTION]: (state, resp) => {
    console.log('TST_DEL_QUESTION mutation initiated', resp)
    const index = state.currentTest.QUESTIONS.findIndex(itm => itm.CDET_ID === resp)
    console.log('Question found - ', index)
    if (index !== -1) {
      state.currentTest.QUESTIONS.splice(index, 1)
      state.currentQuestion = {}
    }
  },
  [TST_ADD_ANSWER]: (state, orderItem) => {
    console.log('TST_ADD_ANSWER mutation initiated', orderItem)
    state.currentQuestion.ANSWERS.push(orderItem)
  },
  [TST_UPD_ANSWER]: (state, orderItem) => {
    console.log('TST_UPD_ANSWER mutation initiated', orderItem)
    const index = state.currentQuestion.ANSWERS.findIndex(itm => itm.ADET_ID === orderItem.ADET_ID)
    console.log('Answer found - ', index)
    if (index !== -1) {
      state.currentQuestion.ANSWERS.splice(index, 1, orderItem)
      state.currentAnswer = orderItem
    }
  },
  [TST_DEL_ANSWER]: (state, resp) => {
    console.log('TST_DEL_ANSWER mutation initiated', resp)
    const index = state.currentQuestion.ANSWERS.findIndex(itm => itm.ADET_ID === resp)
    console.log('Answer found - ', index)
    if (index !== -1) {
      state.currentQuestion.ANSWERS.splice(index, 1)
      state.currentAnswer = {}
    }
  },
  [TST_CANCEL_TEST]: (state, resp) => {
    console.log('TST_CANCEL_TEST mutation called. RESP is ', resp)
    var TSTIndex = state.testList.findIndex(TST => TST.DOC_ID === resp.DOC_ID)
    if (TSTIndex !== -1) {
      state.testList.splice(TSTIndex, 1)
    }
  },
  [TST_POST_TEST]: (state, resp) => {
    console.log('TST_POST_TEST mutation called. RESP is ', resp)
    var TSTItem = state.testList.find(TST => TST.DOC_ID === resp.DOC_ID)
    if (typeof TSTItem !== 'undefined') {
      switch (resp.PTC) {
        case 'type':
          TSTItem.DT_ID = resp.DT_ID
          break
        case 'state':
          TSTItem.EXEC_DOC_STATUS = resp.EXEC_DOC_STATUS
          break
        case 'time':
          TSTItem.SCHEDULED_TIME = resp.TIME
          break
        case 'endtest':
          TSTItem.SCHEDULED_TIME = resp.SHEDULED_TIME
          TSTItem.EXEC_DOC_STATUS = '1'
          TSTItem.DS_ID = resp.DS_ID
          break
        default:
          break
      }
    }
  },
  [TST_ADD_FILE]: (state, responce) => {
    console.log('TST_ADD_FILE mutation called, payload ', responce)
    state.currentTest.FILE_LIST.push(responce)
  },
  [TST_DEL_FILE]: (state, responce) => {
    console.log('TST_DEL_FILE mutation called, payload ', responce)
    const index = state.currentTest.FILE_LIST.findIndex(itm => itm.DD_ID === responce.DD_ID)
    state.currentTest.FILE_LIST.splice(index, 1)
  },
  [TST_CHANGE_COMMENT]: (state, responce) => {
    console.log('TST_CHANGE_COMMENT mutation called, payload ', responce)
    state.currentTest.COMMENTS_TAB = responce
  },
  [TST_GET_USERS]: (state, responce) => {
    console.log('TST_GET_USERS mutation called, payload ', responce)
    state.usersList = responce
  },
  [TST_ADD_USER]: (state, responce) => {
    console.log('TST_ADD_USER mutation called, payload ', responce)
    responce.forEach(element => {
      state.currentTest.USERS.push(element)
      var idx = state.usersList.findIndex(itm => itm.USR_ID === element.USR_ID)
      if (idx !== -1) state.usersList.splice(idx, 1)
    })
  },
  [TST_DEL_USER]: (state, responce) => {
    console.log('TST_DEL_USER mutation called, payload ', responce)
    responce.forEach(element => {
      var idx = state.currentTest.USERS.findIndex(itm => itm.USR_ID === element.USR_ID)
      if (idx !== -1) state.currentTest.USERS.splice(idx, 1)
      state.usersList.push(element)
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
